import React from "react";

class RegisterNotYet extends React.Component{
  render(){
    return(
      <div>
        <p>Registration opens on <strong>12 Nov 2018</strong> and closes on <strong>9 Feb 2019</strong>.</p>
        <p>Are you looking for a new challenge?</p>
        <p>Do you want to solve problems like a Data Scientist?</p>
        <p><strong>Come join us in this challenge today!</strong></p>
        <a href="https://docs.google.com/forms/d/e/1FAIpQLSco5XYqHO_qJQ4D_j38CyF1cXwEMqnKoA5JEn1-f8--ajqIow/viewform" className="btn btn-primary">Register Now</a>
      </div>
    )
  }
}

class RegisterOnGoing extends React.Component{
  render(){
    return(
      <div>
        <p>Registration closes on <strong>9 Feb 2019</strong>.</p>
        <p>Are you looking for a new challenge?</p>
        <p>Do you want to solve problems like a Data Scientist?</p>
        <p><strong>Come join us in this challenge today!</strong></p>
        <a href="https://docs.google.com/forms/d/e/1FAIpQLSco5XYqHO_qJQ4D_j38CyF1cXwEMqnKoA5JEn1-f8--ajqIow/viewform" className="btn btn-primary">Register Now</a>
      </div>
    )
  }
}

class RegisterClose extends React.Component{
  render(){
    return(
      <div>
        <p>Unfortunately, registration for the National Data Science Challenge 2019 has closed.</p>
        <p>Do look forward to our future events!</p>
        <p>Participants who confirmed after 26 February 2019 will not be eligible to take part in the competition.</p>
      </div>
    )
  }
}

class Register extends React.Component {
  constructor() {
    super();
    this.entry = undefined;
  }

  render() {
    // Register Start 12 Nov 2018 @12:00am (UTC) 1541980800000
    // Register Start 9 Feb 2019 @23:59:59 (UTC) 1549756799000
    // Date: new Date().getTime()
    const regStart = 1541980800000,
      regEnd = 1549756799000,
      today = new Date().getTime();
    if (today < regStart) {
      this.entry = <RegisterNotYet />;
    } else if (today > regStart & today < regEnd) {
      this.entry = <RegisterOnGoing />;
    } else if (today > regEnd) {
      this.entry = <RegisterClose />;
    } else{
      this.entry = <RegisterNotYet />;
    }
    
    return (
      <section id="register">
        <div className="container">
          <div className="title-block">
            <h2>Register</h2>
          </div>
          {this.entry}
        </div>
      </section>
    )
  }
};

export default Register;